import React from "react";
import { useDispatch } from "react-redux";
import { Avatar, Popover } from "antd";
import { userSignOut } from "appRedux/actions/Auth";
import smvs_logo from "../../assets/images/smvs_logo.png"

const UserInfo = () => {
  const dispatch = useDispatch();

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li onClick={() => dispatch(userSignOut())}>Logout</li>
    </ul>
  );

  return (
    <Popover
      overlayClassName="gx-popover-horizantal"
      placement="bottomRight"
      content={userMenuOptions}
      trigger="click"
    >
      <Avatar
        className="gx-avatar gx-pointer gx-text-uppercase gx-fs-xl"
        alt=""
        src={smvs_logo}
      >
        {/* Admin */}
      </Avatar>
    </Popover>
  );
};

export default UserInfo;
